<template>
  <div class="search--page">
    <!-- <h1 class="home-title">Talk 工控</h1> -->
    <van-nav-bar title="搜索" left-arrow @click-left="goBack" />
    <van-search
      ref="search"
      placeholder="搜索资讯"
      v-model="searchVal"
      @focus="handleFocus"
      @keyup="handleKey"
      @keypress="searchGoods"
      show-action
      shape="round"
      >
      <div slot="action" @click="selectArticle">搜索</div>
    </van-search>
    <div v-if="searchVal">
      <van-cell-group>
        <van-cell v-for="suggest in suggestList" :key="suggest.Id" @click="selectArticle(suggest)">
          <template slot="title">
            <div v-html="MarkeTitle(suggest.Title)"></div>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <div v-else class="w">
      <div class="tag-box mart-10" v-if="historyTags.length">
        <div class="row-flex">
          <span class="text-gray row-flex-eq text-small">历史搜索</span>
          <van-icon class="text-gray" :size="18" name="delete" @click="deleteHistroy"/>
        </div>
        <div class="tag-group row-flex-base">
          <div
            class="md-tag ellipsis"
            @click="selectTag(tag)"
            v-for="(tag, idx) in historyTags"
            :key="idx"
            round
          >{{tag}}</div>
        </div>
      </div>
      <div class="tag-box mart-10" v-if="hotTags.length">
        <div class="row-flex">
          <span class="text-gray row-flex-eq text-small">热门搜索</span>
        </div>
        <div class="tag-group row-flex-base">
          <div
            class="md-tag ellipsis"
            @click="selectTag(tag, 1)"
            v-for="(tag, idx) in hotTags"
            :key="idx"
            round
          >{{tag}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import cateTabs from '@/views/home/components/cateTabs.vue'
import commonMix from "@/mixins/commonMix.js";
import { Cms } from "@/api";
export default {
  name: "search",
  mixins: [commonMix],
  components: {
    // cateTabs
  },
  data() {
    return {
      showSuggest: false,
      showTags: true,
      searchVal: "",
      historyTags: [],
      hotTags: [],
      suggestList: [],
      testStr: "",
      hisSessionKey: "hisTagsSession"
    };
  },
  created() {
    let searchValue = this.$route.query.value
    if (searchValue && searchValue.length > 0) {
      this.searchVal = searchValue
      this.handleFocus()
    }
    this.getHotTags();
    this.getHistoryTags();
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.search.querySelector('input').focus()
    })
  },
  methods: {
    handleFocus() {
      this.showSuggest = true;
      this.showTags = false;
      this.getSuggestList();
    },
    // handleBlur() {
    //   this.showSuggest = false;
    //   this.showTags = true;
    // },
    MarkeTitle(title) {
      return this.$mdUtils.MarkeStr(title, this.searchVal)
    },
    getSuggestList() {
      this.$api(Cms.Search, { Terms: this.searchVal }).then(res => {
        if (res) {
          this.suggestList = res.List;
        }
      });
    },
    getHotTags() {
      this.$api(Cms.QueryHotTerms, {}).then(res => {
        if (res) {
          this.hotTags = res.Terms;
        }
      });
    },
    deleteHistroy() {
      this.$dialog
        .confirm({
          message: "确认删除所有历史记录？",
          showCancelButton: true
        })
        .then((res) => {
          if (res === 'confirm') {
            this.historyTags = [];
            this.$mdUtils.remove(this.hisSessionKey);
          }
        });
    },
    setHistoryTag(tag) {
      if (!tag) return;
      let currIdx = this.historyTags.findIndex(h => h === tag);

      if (currIdx >= 0) {
        this.historyTags.splice(currIdx, 1)
      }
      this.historyTags.unshift(tag);
      if (this.historyTags.length > 10) {
        this.historyTags = this.historyTags.slice(0, 10)
      }
      this.$mdUtils.setStore(this.hisSessionKey, this.historyTags);
    },
    getHistoryTags() {
      let htags = this.$mdUtils.getStore(this.hisSessionKey);
      if (htags) this.historyTags = htags;
    },
    selectArticle(suggest) {
      if (suggest && suggest.Title) {
        this.searchVal = suggest.Title
      }
      // 记录当前搜索关键字
      this.setHistoryTag(this.searchVal);
      
      this.$router.push({
        path: "/searchResult",
        query: { key: this.searchVal }
      });
    },
    searchGoods(event) {
      if (event.keyCode == 13) {
        event.preventDefault(); //禁止默认事件（默认是换行）
        this.searchVal = event.target.value;
        this.selectArticle();
      }
    },
    handleKey() {
      this.getSuggestList();
    },
    selectTag(tag) {
      this.searchVal = tag;
      this.selectArticle();
    },
    handleChannl() {
      this.searchVal = "";
      this.$router.push("/home");
    }
  }
};
</script>

<style scoped lang="scss">
.w {
  padding: 0 22px;
}
.search--page {
  .home-title {
    font-size: 18px;
    line-height: 46px;
    font-weight: bold;
    margin: 0;
    text-align: center;
    border-bottom: 1px solid $gray;
  }

  .tag-box + .tag-box {
    border-top: 1px solid $gray;
    padding-top: 10px;
  }
}
</style>
